// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1L3Xt","rootSuccess":"CompleteLink_rootSuccess__yUe1z","rootFailure":"CompleteLink_rootFailure__TMHTU","isDisabled":"CompleteLink_isDisabled__2Myt9"};